/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb2niw_Point_0_LabelInputs */

const en_visa_eb2niw_point_0_label = /** @type {(inputs: Visa_Eb2niw_Point_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Professional Profile`)
};

const pt_visa_eb2niw_point_0_label = /** @type {(inputs: Visa_Eb2niw_Point_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil Profissional`)
};

const es_visa_eb2niw_point_0_label = /** @type {(inputs: Visa_Eb2niw_Point_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil Profesional`)
};

/**
* | output |
* | --- |
* | "Professional Profile" |
*
* @param {Visa_Eb2niw_Point_0_LabelInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb2niw_point_0_label = /** @type {((inputs?: Visa_Eb2niw_Point_0_LabelInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb2niw_Point_0_LabelInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb2niw_point_0_label(inputs)
	if (locale === "es") return es_visa_eb2niw_point_0_label(inputs)
	return en_visa_eb2niw_point_0_label(inputs)
});